import { createAction } from 'automation-ui-core/ambient-types/flux-actions';
import * as ActionTypes from 'automation-ui-canvas/actions/ActionTypes';
export const setAiGeneratedActions = createAction(ActionTypes.SET_AI_GENERATED_ACTIONS, generationResponse => {
  return generationResponse;
});
export const setAiGeneratedEnrollment = createAction(ActionTypes.SET_AI_GENERATED_ENROLLMENT, generationResponse => {
  return generationResponse;
});
export const setAiActionsPrompt = createAction(ActionTypes.SET_AI_ACTIONS_PROMPT, actionsPrompt => {
  return actionsPrompt;
});